import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div
      className="flex min-h-screen items-center justify-center px-6"
      style={{ background: 'var(--surface-base)', color: 'var(--text-primary)' }}
    >
      <div className="text-center">
        <p className="mb-4 font-mono tabular text-sm" style={{ color: 'var(--text-muted)' }}>
          404
        </p>
        <h1 className="mb-3 text-2xl">Esta pagina no existe.</h1>
        <p className="mb-6 text-sm" style={{ color: 'var(--text-secondary)' }}>
          Quiza la URL cambio, o nunca existio.
        </p>
        <Link to="/" className="no-underline">
          <Button variant="primary">Volver al inicio</Button>
        </Link>
      </div>
    </div>
  );
}
